module.exports = __webpack_public_path__ + "static/media/wa.456e3f00.png";